import React, { ComponentType } from 'react';
import { NoticeProps, components } from 'react-select';
import { DestinationOption } from '@lt/api/dist/methods/references/types';

export const NoOptionsMessage: ComponentType<NoticeProps<DestinationOption, false>> = (props) => (
  <components.NoOptionsMessage {...props}>
    <span>Ничего не найдено</span>
  </components.NoOptionsMessage>
);
